import { createListLoadingReducer } from './utils';
import { BookingLog } from '@/types';

export default createListLoadingReducer<BookingLog>('BOOKING_LOGS');
